import React from 'react';
import { Image } from 'semantic-ui-react';
// import '../../assets/css/style.css';
import usaTodayLogo
  from '../../../../../assets/images/usa-today-sports-color-extreme-horizontal-rgb.svg';

const sidebarMenuHeaderStyle = {
  height: '60px',
  backgroundColor: '#ffffff',
  boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.08)',
  textAlign: 'left',
  display: 'flex',
  alignItems: 'center',
  borderBottom: '0px',
};

const SidebarFooter = () => (
  <div style={sidebarMenuHeaderStyle}>
    <Image src={usaTodayLogo} alt="logo" centered />
  </div>
);

export default SidebarFooter;



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/SidebarFooter.js